export default __webpack_public_path__ + "static/media/aperol-alkoholicky-campari-orange.d6fb8ba0.jpg";